export default class GTag
{
    static add(event, params)
    {
        window.dataLayer.push({
            event: `tvf3d.${event}`,
            ...params
        })
        // console.log('Event:', event, 'Params:', params)
    }
}